import script from './component-lib.esm86.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'blogger'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M29.931 12h-1.794c-1.099 0-2.062-0.929-2.137-2v0c0-5.708-4.602-10-10.35-10h-5.245c-5.744 0-10.402 4.625-10.406 10.333v11.337c0 5.708 4.662 10.329 10.406 10.329h11.201c5.748 0 10.394-4.621 10.394-10.329v-7.324c0-1.141-0.92-2.346-2.069-2.346zM10 8h6c1.1 0 2 0.9 2 2s-0.9 2-2 2h-6c-1.1 0-2-0.9-2-2s0.9-2 2-2zM22 24h-12c-1.1 0-2-0.9-2-2s0.9-2 2-2h12c1.1 0 2 0.9 2 2s-0.9 2-2 2z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };